import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormArray, FormControl, FormBuilder, Validators } from '@angular/forms';

import { CommonService, SessionStorageService, PageContentService, CodedService, ConfigService } from '../../core/index.service';
import { PageContent } from '../../core/index.model';
import { PhoneNumber } from '../../core/index.model';

import { PhoneType } from '../../core/enumtype';
import { PhonePipe, ExtensionPipe } from '../pipes/index';

@Component({
    selector: 'pnx-phonenumber',
    templateUrl: './phonenumber.control.html',
    providers: [PhonePipe, ExtensionPipe]
})
export class PhoneNumberControl implements OnInit {

    @Input() labelIdPrimary: string = '';
    @Input() defaultLabelPrimary: string = 'Primary Phone';
    @Input() labelPrimary: string = '';
    @Input() labelIdAlternate: string = '';
    @Input() defaultLabelAlternate: string = 'Alternate Phone';
    @Input() labelAlternate: string = '';

    @Input() placeholderPhoneType: string = '';
    @Input() placeholderCarrier: string = '';
    @Input() pagecontent: PageContent;

    @Input() ShowPrimary: boolean = false;
    @Input() ShowExtension: boolean = false;
    @Input() ShowPhoneType: boolean = false;
    @Input() ShowCarrier: boolean = false;
    @Input() ReadOnly: boolean = false;
    @Input() Mandatory: boolean = true;
    @Input() PhoneTypeValue: string;
    @Input() PhoneNumber: PhoneNumber[];
    @Input() IsJurisScr: boolean = false;
    Form: FormGroup;

    isEdit: boolean = false;
    isValidNumber: boolean = false;
    isValidPrimaryNumber: boolean = false;
    isValidAlternateNumber: boolean = false;

    hdnPrimaryCarrier: boolean = true;
    hdnAlternateCarrier: boolean = true;
    PhoneType: any;
    Carrier: any;

    constructor(
        private fb: FormBuilder,
        private phonePipe: PhonePipe,
        private extensionPipe: ExtensionPipe,
        private commonService: CommonService,
        private storageService: SessionStorageService,
        private pagecontentService: PageContentService,
        private codedService: CodedService
    ) { }


    ngOnInit() {

        this.formGroup();

        if (this.PhoneNumber) {
            this.bindPhoneNumber(this.PhoneNumber);
        }

        if (this.pagecontent) {
            if (!this.pagecontentService.pageContent) {
                this.pagecontentService.pageContent = this.pagecontent;
            }
        }
        this.PhoneType = this.getCodedList(1082);
        this.Carrier = this.getCodedList(4081);

    }
    ngOnChanges() {
        this.placeholderPhoneType = this.pagecontentService.getKeyTxt('Phone_Type', this.storageService.getLang());
        this.placeholderCarrier = this.pagecontentService.getKeyTxt('Phone_CarrierText', this.storageService.getLang());

        let labelValuePrimary = (this.labelIdPrimary) ? this.pagecontentService.getKeyTxt(this.labelIdPrimary, this.storageService.getLang()) : this.labelPrimary;
        this.labelPrimary = (labelValuePrimary) ? labelValuePrimary : this.defaultLabelPrimary;


        let labelValueAlternate = (this.labelIdAlternate) ? this.pagecontentService.getKeyTxt(this.labelIdAlternate, this.storageService.getLang()) : this.labelAlternate;
        this.labelAlternate = (labelValueAlternate) ? labelValueAlternate : this.defaultLabelAlternate;

    }

    getCodedList(CodeID: number): any {

        let CodedValue = [];
        if (CodeID && this.storageService.getJurisNo()) {
            this.codedService.GetCodedValues(this.storageService.getJurisNo().toString(), CodeID.toString())
                .then(response => {
                    for (let i = 0; i < response.length; i++) {
                        let objCoded = {
                            value: response[i].CodeValue,
                            viewValue: response[i].Description
                        };
                        CodedValue.push(objCoded);
                    }
                });
        }
        return CodedValue;
    }



    // From Control Group

    formGroup() {

        this.Form = this.fb.group({
            PhoneNumber: this.fb.array([])
        });

        const phoneCtrl = <FormArray>this.Form.controls['PhoneNumber'];
        phoneCtrl.push(this.phoneCtrl());
        if (!this.ShowPrimary) {
            phoneCtrl.push(this.altphoneCtrl());
        }

        if (this.Mandatory) {
            this.Form.controls.PhoneNumber["controls"][PhoneType.Primary]["controls"].PhoneNbr.setValidators([Validators.required, Validators.minLength(10)]);
        }

        if (this.PhoneTypeValue) {
            this.Form.controls.PhoneNumber["controls"][PhoneType.Primary]["controls"].PhoneType.setValue(this.PhoneTypeValue);
        }
    }

    // Primary Number

    phoneCtrl(): FormGroup {
        return this.fb.group({
            PhoneID: [],
            JurisID: [],
            RefID: [],
            RefType: [],
            PhoneNbr: [],
            PhoneType: [],
            Extension: [],
            Carrier: [],
            IsRcvTxt: [],
            IsActive: [1]
        });
    }

    // Alternate Number

    altphoneCtrl(): FormGroup {
        return this.fb.group({
            PhoneID: [],
            JurisID: [],
            RefID: [],
            RefType: [],
            PhoneNbr: [],
            PhoneType: [],
            Extension: [],
            Carrier: [],
            IsRcvTxt: [],
            IsActive: [1]
        });
    }

    // Initialize From Group If not initialized

    InitializeFormGroup() {
        if (!this.Form.controls) {
            this.formGroup();
        }
    }

    // Clear Form Values

    clearForm() {
        this.Form.reset();
        this.isValidNumber = false;
        this.isValidPrimaryNumber = false;
        this.isValidAlternateNumber = false;
        this.isEdit = false;
    }

    clearValidators() {
        this.Form.controls.PhoneNumber["controls"][PhoneType.Primary]["controls"].PhoneNbr.clearValidators();
    }
 
    onPhoneTypeChange(phoneType: number, selValue: string) {

        switch (phoneType) {
            case PhoneType.Primary:
                {
                    this.hdnPrimaryCarrier = selValue === 'M' ? false : true;
                }
                break;
            case PhoneType.Alternate:
                {
                    this.hdnAlternateCarrier = selValue === 'M' ? false : true;
                }
                break;
            default:
        }
    }

    // Bind Phone Value to Form Controls

    bindPhoneNumber(objPhoneNumber: PhoneNumber[]) {

        if (this.PhoneType) {
            this.PhoneType = this.getCodedList(1082);
        }

        if (this.Carrier) {
            this.Carrier = this.getCodedList(4081);
        }

        if (objPhoneNumber[PhoneType.Primary] || objPhoneNumber[PhoneType.Alternate]) {
            this.PhoneNumber = objPhoneNumber;
        }

        this.InitializeFormGroup();

        if (objPhoneNumber[PhoneType.Primary] && this.Form) {
            this.isEdit = true;
            this.Form.controls.PhoneNumber["controls"][PhoneType.Primary]["controls"].PhoneID.setValue(this.isNull(objPhoneNumber[PhoneType.Primary].PhoneID));
            this.Form.controls.PhoneNumber["controls"][PhoneType.Primary]["controls"].RefID.setValue(this.isNull(objPhoneNumber[PhoneType.Primary].RefID));
            this.Form.controls.PhoneNumber["controls"][PhoneType.Primary]["controls"].JurisID.setValue(this.isNull(objPhoneNumber[PhoneType.Primary].JurisID));
            this.Form.controls.PhoneNumber["controls"][PhoneType.Primary]["controls"].PhoneNbr.setValue(this.isNull(objPhoneNumber[PhoneType.Primary].PhoneNbr));
            this.Form.controls.PhoneNumber["controls"][PhoneType.Primary]["controls"].Extension.setValue(this.isNull(objPhoneNumber[PhoneType.Primary].Extension));
            this.Form.controls.PhoneNumber["controls"][PhoneType.Primary]["controls"].PhoneType.setValue(this.isNull(objPhoneNumber[PhoneType.Primary].PhoneType));
            this.Form.controls.PhoneNumber["controls"][PhoneType.Primary]["controls"].Carrier.setValue(
                this.isNull(objPhoneNumber[PhoneType.Primary].Carrier ? objPhoneNumber[PhoneType.Primary].Carrier.trim() : objPhoneNumber[PhoneType.Primary].Carrier)
            );
            this.Form.controls.PhoneNumber["controls"][PhoneType.Primary]["controls"].IsRcvTxt.setValue(this.isNull(objPhoneNumber[PhoneType.Primary].IsRcvTxt));
            this.Form.controls.PhoneNumber["controls"][PhoneType.Primary]["controls"].IsActive.setValue(this.isNull(objPhoneNumber[PhoneType.Primary].IsActive));
        }

        if (!this.ShowPrimary && objPhoneNumber[PhoneType.Alternate] && this.Form) {
            this.isEdit = true;
            this.Form.controls.PhoneNumber["controls"][PhoneType.Alternate]["controls"].PhoneID.setValue(this.isNull(objPhoneNumber[PhoneType.Alternate].PhoneID));
            this.Form.controls.PhoneNumber["controls"][PhoneType.Alternate]["controls"].RefID.setValue(this.isNull(objPhoneNumber[PhoneType.Alternate].RefID));
            this.Form.controls.PhoneNumber["controls"][PhoneType.Alternate]["controls"].JurisID.setValue(this.isNull(objPhoneNumber[PhoneType.Alternate].JurisID));
            this.Form.controls.PhoneNumber["controls"][PhoneType.Alternate]["controls"].PhoneNbr.setValue(this.isNull(objPhoneNumber[PhoneType.Alternate].PhoneNbr));
            this.Form.controls.PhoneNumber["controls"][PhoneType.Alternate]["controls"].Extension.setValue(this.isNull(objPhoneNumber[PhoneType.Alternate].Extension));
            this.Form.controls.PhoneNumber["controls"][PhoneType.Alternate]["controls"].PhoneType.setValue(this.isNull(objPhoneNumber[PhoneType.Alternate].PhoneType));
            this.Form.controls.PhoneNumber["controls"][PhoneType.Alternate]["controls"].Carrier.setValue(
                this.isNull(objPhoneNumber[PhoneType.Alternate].Carrier ? objPhoneNumber[PhoneType.Alternate].Carrier.trim() : objPhoneNumber[PhoneType.Alternate].Carrier)
            );
            this.Form.controls.PhoneNumber["controls"][PhoneType.Alternate]["controls"].IsRcvTxt.setValue(this.isNull(objPhoneNumber[PhoneType.Alternate].IsRcvTxt));
            this.Form.controls.PhoneNumber["controls"][PhoneType.Alternate]["controls"].IsActive.setValue(this.isNull(objPhoneNumber[PhoneType.Alternate].IsActive));
        }
    }

    isNull(objVal: any) {
        return (objVal) ? objVal : "";
    }

    // Get the Phone Details from Form Controls

    getPhoneNumber(): PhoneNumber[] {

        this.markAsTouched();
        this.validatePhone(this.Form.controls.PhoneNumber.value);

        this.setIDFields();

        return this.Form.controls.PhoneNumber.value;
    }

    setIDFields() {

        if (!this.isEdit) {
            for (let i = 0; i <= this.Form.controls.PhoneNumber["controls"].length - 1; i++) {
                this.Form.controls.PhoneNumber["controls"][i]["controls"].JurisID.setValue(this.storageService.getJurisNo());

                if (this.PhoneNumber && this.PhoneNumber[i]) {
                    this.Form.controls.PhoneNumber["controls"][i]["controls"].PhoneID.setValue(this.PhoneNumber[i].PhoneID);
                    this.Form.controls.PhoneNumber["controls"][i]["controls"].RefID.setValue(this.PhoneNumber[i].RefID);
                    this.Form.controls.PhoneNumber["controls"][i]["controls"].JurisID.setValue(this.PhoneNumber[i].JurisID);
                }
            }
        }

    }

    // To Highlight Mandatory Fields

    markAsTouched() {
        this.Form.controls.PhoneNumber["controls"][PhoneType.Primary]["controls"].PhoneNbr.markAsTouched();
    }

    // Validate Phone Number From the Given Input

    validatePhone(phone: PhoneNumber[]) {

        if (phone.length > PhoneType.Primary && phone[PhoneType.Primary].PhoneNbr && phone[PhoneType.Primary].PhoneNbr !== "") {
            this.isValidPrimaryNumber = this.commonService.phoneNumber(phone[PhoneType.Primary].PhoneNbr);
            this.isValidNumber = this.commonService.phoneNumber(phone[PhoneType.Primary].PhoneNbr);
        }

        if (phone.length > PhoneType.Alternate && phone[PhoneType.Alternate].PhoneNbr && phone[PhoneType.Alternate].PhoneNbr !== "") {
            this.isValidAlternateNumber = this.commonService.phoneNumber(phone[PhoneType.Alternate].PhoneNbr);
            this.isValidNumber = this.commonService.phoneNumber(phone[PhoneType.Alternate].PhoneNbr);
        }

        if (phone.length > PhoneType.Alternate && phone[PhoneType.Primary].PhoneNbr && phone[PhoneType.Primary].PhoneNbr !== "" && phone[PhoneType.Alternate].PhoneNbr && phone[PhoneType.Alternate].PhoneNbr !== "") {

            if (this.commonService.phoneNumber(phone[PhoneType.Primary].PhoneNbr) && !this.commonService.phoneNumber(phone[PhoneType.Alternate].PhoneNbr)) {
                this.isValidPrimaryNumber = false;
                this.isValidNumber = false;
            }
            else if (!this.commonService.phoneNumber(phone[PhoneType.Primary].PhoneNbr) && this.commonService.phoneNumber(phone[PhoneType.Alternate].PhoneNbr)) {
                this.isValidAlternateNumber = false;
                this.isValidNumber = false;
            }
            else if (this.commonService.phoneNumber(phone[PhoneType.Primary].PhoneNbr) && this.commonService.phoneNumber(phone[PhoneType.Alternate].PhoneNbr)) {
                this.isValidPrimaryNumber = true;
                this.isValidAlternateNumber = true;
                this.isValidNumber = true;
            }
        }
    }
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/controls/phonenumber.control.ts